import { render, staticRenderFns } from "./AddStuff.vue?vue&type=template&id=4bbc9165&scoped=true&"
import script from "./AddStuff.vue?vue&type=script&lang=js&"
export * from "./AddStuff.vue?vue&type=script&lang=js&"
import style0 from "./AddStuff.vue?vue&type=style&index=0&id=4bbc9165&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bbc9165",
  null
  
)

export default component.exports